export default "__VITE_ASSET__951f8f1e__"